import mock from 'src/utils/mock';
import { TestDataType as TestDataTypeInterface } from 'src/types/test';
const test: TestDataTypeInterface[] = [
    {
        TestID: 7003,
        TestType: 'Haematology',
        DisplayName: 'DLC',
        Description: 'Differential Leucocyte Count',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7004,
        TestType: 'Haematology',
        DisplayName: 'DLC-AC',
        Description: 'Differential Leukocyte Count (Absolute count)',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7009,
        TestType: 'Haematology',
        DisplayName: 'BRH',
        Description: 'Blood Group & Rh',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7013,
        TestType: 'Haematology',
        DisplayName: 'MP (Card Test)',
        Description: 'Malaria Parasite (Card Test)',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7024,
        TestType: 'Haematology',
        DisplayName: 'PT/INR',
        Description: 'Prothrombin time|PT|INR',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7025,
        TestType: 'Haematology',
        DisplayName: 'APTT',
        Description: 'Activated partial thromboplastin time|APTT',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7063,
        TestType: 'Biochemistry',
        DisplayName: 'GTT',
        Description: 'Glucose Tolerance Test|GTT',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7067,
        TestType: 'Biochemistry',
        DisplayName: 'HBA1C',
        Description: 'HbA1c',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7110,
        TestType: 'Biochemistry',
        DisplayName: 'ABG',
        Description: 'Arterial Blood Gas',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7117,
        TestType: 'Serology & Immunology',
        DisplayName: 'WID-TEST(sm)',
        Description: 'Widal Test (Slide Method)',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7118,
        TestType: 'Serology & Immunology',
        DisplayName: 'MALA-ANTI',
        Description: 'Malaria Antigen',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7119,
        TestType: 'Serology & Immunology',
        DisplayName: 'HIV-CARD',
        Description: 'HIV (Card Test)',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7124,
        TestType: 'Serology & Immunology',
        DisplayName: 'TYPH-ANTI',
        Description: 'Typhidot Antibodies',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7125,
        TestType: 'Serology & Immunology',
        DisplayName: 'RUBELLA',
        Description: 'Rubella',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7133,
        TestType: 'Serology & Immunology',
        DisplayName: 'DENG-CARD',
        Description: 'Dengue (Card Method)',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7153,
        TestType: 'Clinical Pathology',
        DisplayName: 'SEME-EXAM',
        Description: 'Semen Examination',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7155,
        TestType: 'Clinical Pathology',
        DisplayName: 'STO-ROUT(EXAM)',
        Description: 'Stool Routine Examination',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7158,
        TestType: 'Clinical Pathology',
        DisplayName: 'URIN-SUG(EXAM)',
        Description: 'Urine Routine Examination',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7159,
        TestType: 'Clinical Pathology',
        DisplayName: 'FLUID-EXAM',
        Description: 'Fluid Examination',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7165,
        TestType: 'Microbiology',
        DisplayName: 'GRAM-STAIN',
        Description: "Gram's Stain",
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
    {
        TestID: 7166,
        TestType: 'Microbiology',
        DisplayName: 'AFB',
        Description: 'Acid - Fast Bacilli',
        Remarks: '',
        IsParmeter: 'N',
        Parent: 'Y',
        SpecimenType: '',
        ReTestIn: 10,
        ObservationType: 'Range',
        ValidFrom: '2023-08-09T10:26:31.437Z',
        ValidUpto: '2050-12-24T10:26:31.437Z',
    },
];

// mock.onGet('/gettTests/').reply(() => {
//     return [200, { data: test }];
// });

mock.onPost('/getTests/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, test]);
        }, 1000);
    });
});

mock.onPost('/getTest/').reply((config) => {
    const params = JSON.parse(config.data);
    const testData = test.filter((item) => item.TestID === params.id)[0];
    return [200, { ...testData }];
});
